import { Injectable } from '@angular/core';
import { BenefitStore } from './benefit.store';
import { tap, mapTo, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ApiService } from '../shared/services/core/api.service';
import { BenefitQuery } from './benefit.query';
import { Benefit } from './models/benefit.model';
import { BenefitClaimLimitModel } from './models/benefit-claim-limit.model';
import { ErrorStateService } from '../shared/services/core/error.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class BenefitService {
  constructor(
    private benefitStore: BenefitStore,
    private api: ApiService,
    private benefitQuery: BenefitQuery,
    private errorService: ErrorStateService
  ) {}

  /** Fetch all the benefits */
  fetchBenefits(): Observable<null> {
    const request$: Observable<null> = this.api.get<Benefit>('benefits').pipe(
      tap((items) => this.benefitStore.set(items)),
      mapTo(null)
    );

    return this.benefitQuery.getHasCache() ? of(null) : request$;
  }

  /** Claim a benefit, returns the benefit claimed */
  claimBenefit(benefit: Benefit): Observable<null> {
    return this.api.postForParent<Benefit>('benefits', benefit.BenefitId, 'claim', benefit).pipe(
      tap((b) => this.benefitStore.upsert(b.BenefitId, b)),
      catchError((err: HttpErrorResponse) => {
        this.errorService.clearErrors();
        this.errorService.addError(err.error.toString());
        throw err;
      }),
      mapTo(null)
    );
  }

  /** Fetches the maximum number of benefits the member can claim */
  fetchLimit(): Observable<null> {
    const request$: Observable<null> = this.api.getChildData<BenefitClaimLimitModel>('benefits', 'limit').pipe(
      tap((limit) => {
        if (limit) {
          this.benefitStore.setLimit(limit.Limit);
        }
      }),
      mapTo(null)
    );

    return request$;
  }
}
